import { createSlice } from "@reduxjs/toolkit";

const apiStatusSlice = createSlice({
  name: "apiStatus",
  initialState: {
    // Single boolean to indicate if any API call is in progress
    isApiLoading: false, 
  },
  reducers: {
    // Action to set loading to true when a request starts
    startLoading: (state) => {
      state.isApiLoading = true;
    },
    // Action to set loading to false when a request finishes (success or failure)
    stopLoading: (state) => {
      state.isApiLoading = false;
    },
  },
});

export const { startLoading, stopLoading } = apiStatusSlice.actions;

export default apiStatusSlice;